<template>
  <div
    v-show="hasToShowAlertForGuest"
    id="guestAlert"
    class="alert-container accent"
    :class="{ 'alert-container-sticky': hasToBeSticky }"
  >
    <div class="d-flex align-center">
      <span
        class="text"
        :class="$breakpoint.tabletAndUp ? 'text-l-large-bold' : 'text-m-large-bold'"
        >Earn special requirements for free.</span
      >
      <v-btn
        class="heading heading-s-small primary--text shadow-light-button"
        :class="{
          'ml-2': $breakpoint.mobileAndDown,
          'ml-4': $breakpoint.tabletAndUp,
        }"
        ripple
        depressed
        height="36px"
        width="auto"
        :to="{ name: 'register' }"
      >
        Start free trial
      </v-btn>
    </div>
  </div>
</template>

<script>
// TODO: deprecated component, we have to remove it

import { upgradeAlertsMixin } from '@/mixins/upgradeAlertsMixin';

export default {
  name: 'SpecialRequirementsAlertGuest',
  mixins: [upgradeAlertsMixin],
  computed: {
    hasToBeSticky() {
      return (
        (this.$route.name !== 'special-requirements' &&
          this.$route.name !== 'special-requirements-topic-states' &&
          this.$breakpoint.tabletAndUp) ||
        this.$breakpoint.mobileAndDown
      );
    },
  },
  watch: {
    '$breakpoint.mobileAndDown'(newValue) {
      this.moveAlertGuest(newValue);
    },
  },
  mounted() {
    this.moveAlertGuest(this.$breakpoint.mobileAndDown);
  },
  methods: {
    moveAlertGuest(isMobile) {
      const alertGuestEl = document.querySelector('#guestAlert');
      const headerEl = document.querySelector('#headerBanner');
      if (isMobile) {
        headerEl.parentNode.insertBefore(alertGuestEl, headerEl);
      } else {
        headerEl.parentNode.insertBefore(alertGuestEl, headerEl.nextSibling);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-container-sticky {
  position: sticky;
}
.alert-container {
  top: 56px;
  z-index: 1;

  min-height: 44px;
  padding: 8px 24px;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  color: white;
  font-weight: 400;
}

@media #{map-get($display-breakpoints, 'mobile-and-down')} {
  .alert-container {
    padding: 8px 16px;
  }
}

@media #{map-get($display-breakpoints, 'small-desktop-and-up')} {
  .alert-container {
    top: 60px;
  }
}
</style>
